import { useEffect } from "react";

const VisitorTracker = () => {
  useEffect(() => {
    const data = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.platform,
      url: window.location.href,
      referrer: document.referrer,
      timestamp: new Date().toISOString(),
    };

    fetch("https://congolinaria.com.br/salvar_visita.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  }, []);

  return null;
};

export default VisitorTracker;
